import defaultState from "./state";

const filtroBusquedaReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "FILTRO_BUSQUEDA":
      return Object.assign({}, state, defaultState);

    case "CARGAR_PRESTACIONES": {
      return Object.assign({}, state, {
        loading: false,
        prestaciones: action.prestaciones,
      });
    }

    case "CARGAR_TIPOS_ATENCION": {
      return Object.assign({}, state, {
        tiposAtencion: action.tiposAtencion,
        filtros: {
          tipoAtencion: "0",
        },
      });
    }

    case "CARGAR_NUEVA_PRESTACION": {
      return Object.assign({}, state, {
        modalNuevaPrestacion: action.modalNuevaPrestacion,
      });
    }

    case "CAMBIAR_TIPO_ATENCION": {
      const filtros = Object.assign({}, state.filtros, {
        tipoAtencion: action.tipoAtencion,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "LOADING": {
      return Object.assign({}, state, {
        loading: action.loading,
      });
    }

    case "LOADINGEXCEL": {
      return Object.assign({}, state, {
        loadingExcel: action.loadingExcel
      })
    }

    case "CARGAR_SOLICITUDES": {
      let idSolicitudAux = null;
      let openModal = false;

      if (action.solicitudes.length > 0) {
        idSolicitudAux = action.solicitudes[0].IdSolicitud;
        openModal = true;
      }
      return Object.assign({}, state, {
        solicitudes: action.solicitudes,
        idSolicitud: idSolicitudAux,
        modalCargarBorrador: openModal,
      });
    }

    case "OPEN_CARGAR_BORRADOR": {
      return Object.assign({}, state, {
        modalCargarBorrador: action.modalAction,
      });
    }

    case "CARGAR_DETALLE_SOLICITUD_FIL": {
      let mostrarmodalAux = false;
      if (action.prestacionesSolicitud.length > 0) {
        mostrarmodalAux = true;
      }

      return Object.assign({}, state, {
        prestacionesSolicitud: action.prestacionesSolicitud,
        modalCargarBorrador: mostrarmodalAux,
        idSolicitud: action.idSolicitud,
      });
    }

    case "ACT_ARANCEL_SET_SOLICITUD_EN_CURSO": {
      return Object.assign({}, state, {
        solicitudEnCurso: action.solicitudEnCurso,
      });
    }

    default:
      return state;
  }
};

export default filtroBusquedaReducer;
